// prime component
import { Skeleton as PrSkeleton } from 'primereact/skeleton'

// Styles
import classes from './styles.module.scss'

// types
import type { SkeletonProps as PrSkeletonProps } from 'primereact/skeleton'
import type { sizeEnums } from '@centria-ui/commons/enums'
import type { FC } from 'react'

export interface SkeletonProps extends PrSkeletonProps {
  radius?: keyof typeof sizeEnums
}

export const Skeleton: FC<SkeletonProps> = ({
  radius = 'xs',
  className = '',
  ...props
}) => (
  <PrSkeleton
    {...props}
    data-cy='skeleton'
    className={`${className} ${
      props.shape !== 'circle' && classes[`skeleton_${radius}`]
    }`}
  />
)
